export default __webpack_public_path__ + "static/media/hht2_ep03_book_wp_01.bf195c46.jpg";